<div class="SLV2-main-wrapper">

    <div class="SLV2-body-section document-body-section">

        <div class="SLV2-section-wrap SLV2-page-header-area">
            <div class="SLV2-page-header-lft">
                <!-- navigateToSelfLearnHomePage() -->
                <button class="SLV2-header-text-button" (click)="navigateToChaperPage()">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
                    <span>{{title}}</span>
                </button>
            </div>
        </div>


        <div class="SLV2-section-wrap" >
            <div class="row _SLV2-sm-gap">
                <ng-container  *ngFor="let doc of docsData">

                <div class="col-xl-6 col-lg-6 col-md-6" (click)="openPdf(doc)">
                    <div class="SLV2-doc-box pointer">
                        <div class="SLV2-doc-icon-wrap"><img src="selflearnv2-ui/assets/img/self-learn-v2/pdf-icon.png" /></div>
                        <div class="SLV2-doc-title">{{doc.title}}</div>
                    </div>
                </div>
            </ng-container>

                <!-- <div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="SLV2-doc-box pointer">
                        <div class="SLV2-doc-icon-wrap"><img src="selflearnv2-ui/assets/img/self-learn-v2/pdf-icon.png" /></div>
                        <div class="SLV2-doc-title">Electric Charges and fields</div>
                    </div>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="SLV2-doc-box pointer">
                        <div class="SLV2-doc-icon-wrap"><img src="selflearnv2-ui/assets/img/self-learn-v2/ppt-icon.png" /></div>
                        <div class="SLV2-doc-title">Electric Charges and fields</div>
                    </div>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="SLV2-doc-box pointer">
                        <div class="SLV2-doc-icon-wrap"><img src="selflearnv2-ui/assets/img/self-learn-v2/pdf-icon.png" /></div>
                        <div class="SLV2-doc-title">Electric Charges and fields</div>
                    </div>
                </div> -->

            </div>
        </div>


    </div>
</div>

